// Canonical Segment event names — each value is the basename of an event file in
// Material-Bank/AnalyticsInstrumentation (schemas/apps/mtag/events/<name>.json) and is
// the exact event name we emit to Segment. As of analytics-events-ts 0.26.4 the mtag plan
// is aligned with MB3: the generic interaction events are `click_event` / `impression_event`
// (mb3 action/element/component/section shape). See @material-bank/analytics-events-ts/mtag.
export const MTAG_EVENTS = {
  IMPRESSION: 'impression_event',
  PRODUCT_VIEWED: 'product_viewed',
  CART_VIEWED: 'cart_viewed',
  PROJECT_CHANGED: 'project_changed',
  PRODUCT_ADDED: 'product_added',
  PRODUCT_REMOVED: 'product_removed',
  PRODUCT_LIST_VIEWED: 'product_list_viewed',
  PRODUCT_LIST_FILTERED: 'product_list_filtered',
  PRODUCT_ADDED_TO_WISHLIST: 'product_added_to_wishlist',
  PRODUCT_REMOVED_FROM_WISHLIST: 'product_removed_from_wishlist',
  SIGNED_IN: 'signed_in',
  SIGN_IN_STEP: 'sign_in_step',
  CREATE_ACCOUNT_STEP: 'create_account_step',
  CHECKOUT_STARTED: 'mtag_checkout_started',
  SPECS_VIEWED: 'specs_viewed',
  SPECS_DOCUMENTS_DOWNLOADED: 'specs_documents_downloaded',
  SPECS_SENT_TO_EMAIL: 'specs_sent_to_email',
  BRAND_REP_CONTACTED: 'brand_rep_contacted',
} as const

export type MtagEventName = (typeof MTAG_EVENTS)[keyof typeof MTAG_EVENTS]

// Required by every canonical event; identifies the app that emitted the event.
export const SOURCE_APP = 'mtag' as const

// Surface an item was interacted with, persisted from add-to-cart through purchase for
// basket analysis. The canonical mtag schema takes a free string here, so each surface
// reports itself rather than being folded into the nearest page.
export const ITEM_LOCATION_CONTEXT = {
  // The gallery is the PDP, named for the MB3 term both apps now share.
  GALLERY_VIEW: 'pdp',
  COLORWAYS: 'colorways',
  SIMILAR_PRODUCTS: 'similar_products',
  PAIRS_WITH: 'pairs_with',
  SPECS: 'specs',
  CART: 'cart',
  ALREADY_SAMPLED_INTERSTITIAL: 'already_sampled_interstitial',
} as const

export type ItemLocationContext =
  (typeof ITEM_LOCATION_CONTEXT)[keyof typeof ITEM_LOCATION_CONTEXT]
